import { useParams } from "@/components/hooks/use-params";
import { NotificationDetailContainer } from "@/containers/notifications/notification-detail";
import { Navigate } from "react-router-dom";

export function NotificationDetailPage() {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <Navigate to="/notifications" />;
  }

  return <NotificationDetailContainer id={id} />;
}
